import React from 'react';
import { IProps } from 'components/Accordion/types';
import Item from 'components/Accordion/Item';
import Header from 'components/Accordion/Header';
import Content from 'components/Accordion/Content';
import Addition from 'components/Accordion/Addition';

class Accordion extends React.Component<IProps, {}> {
  static Item = Item as typeof Item;
  static Header = Header as typeof Header;
  static Content = Content as typeof Content;
  static Addition = Addition as typeof Addition;

  render () {
    return (
      <div className="accordion">
        {this.props.children}
      </div>
    );
  }
};

export default Accordion;
